import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'haStatePipe'
})
export class HaStatePipePipe implements PipeTransform {

 
  transform(roleData: any[],  searchTermstate: string): any[] {
    if (!roleData || !searchTermstate) { return roleData; }
    return roleData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTermstate.toLowerCase().trim()) !== -1
     
    



    );
  }


}
